import React from 'react';


function LoadingScreen() {
  return (
    <div className="loading-screen">
      <div className="loading-container">
        <div className="spinner-container">
          <div className="spinner"></div>
        </div>
        <h2 className="loading-text">Loading your dashboard...</h2>
      </div>
    </div>
  );
}

export default LoadingScreen;